import { sleep } from './sleep';

const loaded = ['AkkuratLL'];
export const loadFont = async (family: string, throughLocalProxy = false) => {
  if (!family) return;
  if (loaded.includes(family)) return;
  const headID = document.getElementsByTagName('head')[0];
  const link = document.createElement('link');
  link.type = 'text/css';
  link.rel = 'stylesheet';

  const size = (await document.fonts.ready)['size'];

  headID.appendChild(link);
  if (throughLocalProxy) {
    link.href =
      '/internal-api/image?url=https://fonts.googleapis.com/css?family=' +
      family.split(' ').join('+') +
      ':wght@400;700;900';
  } else {
    link.href = 'https://fonts.googleapis.com/css?family=' + family.split(' ').join('+') + ':wght@400;700;900';
  }
  loaded.push(family);

  await waitForFontLoaded(family, size);
};

const waitForFontLoaded = async (family: string, size: number, tries = 0) => {
  if (tries > 150) {
    console.warn('Font not loaded', family);
    return;
  }
  const currentLoadedFonts = (await document.fonts.ready)['size'];
  if (currentLoadedFonts !== size) return;
  await sleep(10);
  return waitForFontLoaded(family, currentLoadedFonts, tries + 1);
};
